import { render, staticRenderFns } from "./changelog-ownership.vue?vue&type=template&id=b3723b7c"
import script from "./changelog-ownership.vue?vue&type=script&lang=js"
export * from "./changelog-ownership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports